// useCurrentLocation.js
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const useCurrentLocation = () => {
  const [isHomePage, setIsHomepage] = useState(true);
  const [currentPath, setCurrentPath] = useState("/");
  const location = useLocation();
  useEffect(() => {
    setIsHomepage(location.pathname === "/");
    setCurrentPath(location.pathname);
  }, [location]);
  return { isHomePage, currentPath };
};

export default useCurrentLocation;
